(function () {
  function initCarousel(section) {
    var track = section.querySelector('[data-vrc-track]');
    var prevBtn = section.querySelector('.vrc-arrow--prev');
    var nextBtn = section.querySelector('.vrc-arrow--next');
    var videos = section.querySelectorAll('.vrc-video');

    if (!track) return;

    function scrollByAmount(dir) {
      var item = track.querySelector('.vrc-item');
      var gap = 16;
      var amount = item ? item.offsetWidth + gap : 260;
      track.scrollBy({ left: dir * amount * 2, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByAmount(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByAmount(1); });

    if (videos.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { root: track, threshold: [0, 0.6, 1] });

      videos.forEach(function (video) {
        video.muted = true;
        video.setAttribute('muted', '');
        observer.observe(video);
      });
    }

    section.addEventListener('click', function (e) {
      var muteBtn = e.target.closest('[data-vrc-mute]');
      if (!muteBtn) return;
      var media = muteBtn.closest('[data-vrc-media]');
      var video = media && media.querySelector('.vrc-video');
      if (!video) return;
      video.muted = !video.muted;
      muteBtn.textContent = video.muted ? '\u{1F507}' : '\u{1F50A}';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.vrc-shopify-section, [id^="vrc-"]').forEach(initCarousel);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initCarousel(e.target);
  });
})();